<div class="offering-addons">
  <h1 class="ui-heading-1-bold offering-addons-title">
    {{ section() }}
  </h1>

  <table rds-table [dataSource]="addonDataSource" density="spacious">
    <ng-container rdsColumnDef="name">
      <th rds-header-cell *rdsHeaderCellDef>Add-on name</th>
      <td rds-cell *rdsCellDef="let element">
        {{ element.name }}
      </td>
    </ng-container>

    <ng-container rdsColumnDef="description">
      <th rds-header-cell *rdsHeaderCellDef>Description</th>
      <td rds-cell *rdsCellDef="let element">
        <span>{{ element.description }}</span>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="cost">
      <th rds-header-cell *rdsHeaderCellDef>Cost information</th>
      <td rds-cell *rdsCellDef="let element">
        <span>{{ element.cost }}</span>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="support">
      <th rds-header-cell *rdsHeaderCellDef>Support availability</th>
      <td rds-cell *rdsCellDef="let element">
        <span>{{ element.support ? 'Available' : 'Not available' }}</span>
      </td>
    </ng-container>

    <ng-container rdsColumnDef="url">
      <th rds-header-cell *rdsHeaderCellDef>Add-on URL</th>
      <td rds-cell *rdsCellDef="let element">
        <a
          class="link"
          rds-link
          standalone
          [href]="element.url"
          target="_blank"
        >
          {{ BUTTONS.CLICK_HERE }}
        </a>
      </td>
    </ng-container>

    <tr rds-header-row *rdsHeaderRowDef="addonColumns"></tr>
    <tr rds-row *rdsRowDef="let row; columns: addonColumns"></tr>
  </table>
</div>
